import Vue from 'vue'
import util from '@/libs/util.js'
// 是否有权限
const hasPermission = btnRoleList => {
  // 如果没有传入权限要求，默认有权限
  if (!btnRoleList || btnRoleList.length === 0) {
    return true
  }
  
  // 当前用户的权限列表
  const permissions = util.cookies.get('permissions')
  
  // 如果没有权限数据，返回无权限
  if (!permissions) {
    return false
  }
  
  const permissionsArr = permissions.split(',')
  
  // 兼容字符串和数组两种传入方式
  const roleList = Array.isArray(btnRoleList) ? btnRoleList : [String(btnRoleList)]
  
  return roleList.some(e => permissionsArr.includes(String(e)))
}

// 指令
const permission = Vue.directive('permission', {
  inserted: (el, binding, vnode) => {
    if (!hasPermission(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
export default permission
// // 全局判断方法
Vue.prototype.$_has = hasPermission
// export { has }